import useBottomSheet from 'hooks/common/useBottomSheet';
import Button from 'components/common/Button';
import { DRAG_BAR_HEIGHT_REM } from 'components/common/BottomSheet';

const UploadPhoto = () => {
  const { close, getSheet } = useBottomSheet();
  const { imgSrc, onSaveImage } = getSheet('UploadPhoto').data;

  const handleUploadAndClose = () => {
    onSaveImage();
    close('UploadPhoto');
  };

  return (
    <div className="relative h-full w-full">
      <div data-component="ProfileImage" className={`h-[100dvw] w-[100dvw] overflow-hidden rounded-lg`} style={{ marginTop: `-${DRAG_BAR_HEIGHT_REM}rem`, marginInline: '-1rem' }}>
        <div className="relative w-full" style={{ height: '100dvw' }}>
          <img src={imgSrc} alt="" className="h-full w-full object-cover" />
          <div className="absolute bottom-0 left-0 right-0 h-[25%] w-full" style={{ background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%)' }} />
          <div className="absolute left-0 right-0 top-0 h-[25%] w-full" style={{ background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%)' }} />
        </div>
      </div>
      <div className="flex gap-[2px] p-2 mt-4">
        <Button
          onClick={handleUploadAndClose}
          className="flex-[5]"
          style={{
            text: 'Upload Photo',
            type: 'solid',
            color: 'btn-bg-primary',
            fontColor: 'btn-txt-primary',
            borderRadius: 'full',
          }}
        />
        <Button
          onClick={() => close('UploadPhoto')}
          className="flex-[1] rounded-l-md rounded-r-xl"
          style={{
            type: 'solid',
            color: 'btn-bg-normal',
            icon: { name: 'profile/close.svg', size: 24 },
          }}
        />
      </div>
    </div>
  );
};
export default UploadPhoto;
